import {ReactNode, useState} from 'react';

import './styles.css';

export const ConfirmCancelButton = ({
  promptText,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm = () => true,
  onCancel = () => true,
  onOpen = () => true,
  additionalContent,
}: {
  promptText: ReactNode,
  confirmText?: ReactNode,
  cancelText?: ReactNode,
  onConfirm?: () => Promise<boolean> | boolean | void,
  onCancel?: () => Promise<boolean> | boolean | void,
  onOpen?: () => Promise<boolean> | boolean | void,
  additionalContent?: ReactNode,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = makePredicatedToggle(onOpen, () => setIsOpen(true));
  const cancel = makePredicatedToggle(onCancel, () => setIsOpen(false));
  const cnnfirm = makePredicatedToggle(onConfirm, () => setIsOpen(false));

  return (
    <div className="ConfirmCancelButton">
      {!isOpen && (
        <button
          onClick={open}
          className="ConfirmCancelButton__button btn btn-primary">
          {promptText}
        </button>
      )}
      {isOpen && (
        <>
          {additionalContent && (
            <div>
              {additionalContent}
            </div>
          )}
          <div>
            <button
              className="ConfirmCancelButton__button btn btn-primary"
              onClick={cnnfirm}
            >
              {confirmText}
            </button>
            <button
              className="ConfirmCancelButton__button btn btn-secondary"
              onClick={cancel}
            >
              {cancelText}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const makePredicatedToggle = (
    predicateFn: () => Promise<boolean> | boolean | void,
    fn: () => void,
) => {
  return async () => {
    const result = await predicateFn();
    if (result) {
      fn();
    }
  };
};

